import Head from "next/head";
import React from "react";
import Meta from "../../../components/Meta";

const EBuyPrivacyPolicy = () => {
  return (
    <div>
      <Meta title="Privacy Policy | eBuy" />
      <div className="pt-[5.5rem] lg:pt-24">
        {/* <!-- TOS --> */}
        <section className="dark:bg-jacarta-800 relative py-16 md:py-24">
          <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden">
            <img
              src="/images/gradient_light.jpg"
              alt="gradient"
              className="h-full w-full"
            />
          </picture>
          <div className="container">
            <h1 className="font-display text-jacarta-700 text-center text-4xl font-medium dark:text-white">
              Privacy Policy
            </h1>
            <div className="article-content mx-auto max-w-[48.125rem]">
              <h2 className="text-base">Introduction</h2>
              <p>
                {
                  "This Privacy Policy govern your access to and use of the eBuy website(s), our APIs, mobile app (the “App”), and any other software, tools, features, or functionalities provided on or in connection with our services; including without limitation using our services to view, explore, and create NFTs and use our tools, at your own discretion, to connect directly with others to purchase, sell, or transfer NFTs on public blockchains (collectively, the “Service”). “NFT” in these Terms means a non-fungible token or similar digital item implemented on a blockchain (such as the Ethereum blockchain), which uses smart contracts to link to or otherwise be associated with certain content or data. For purposes of these Terms, “user”, “you”, and “your” means you as the user of the Service. If you use the Service on behalf of a company or other entity then “you” includes you and that entity, and you represent and warrant that (a) you are an authorized representative of the entity with the authority to bind the entity to these Terms, and (b) you agree to these Terms on the entity's behalf."
                }
              </p>
              <p>
                PLEASE READ THIS PRIVACY POLICY CAREFULLY AS THEY CONTAIN
                IMPORTANT INFORMATION AND AFFECT YOUR LEGAL RIGHTS. AS OUTLINED
                IN SECTION 16 BELOW, THEY INCLUDE A MANDATORY ARBITRATION
                AGREEMENT AND className ACTION WAIVER WHICH (WITH LIMITED
                EXCEPTIONS) REQUIRE ANY DISPUTES BETWEEN US TO BE RESOLVED
                THROUGH INDIVIDUAL ARBITRATION RATHER THAN BY A JUDGE OR JURY IN
                COURT.
              </p>
              <p>
                BY CLICKING TO ACCEPT AND/OR USING OUR SERVICE, YOU AGREE TO BE
                BOUND BY THIS PRIVACY POLICY AND ALL OF THE TERMS INCORPORATED
                HEREIN BY REFERENCE. IF YOU DO NOT AGREE TO THIS PRIVACY POLICY,
                YOU MAY NOT ACCESS OR USE THE SERVICE.
              </p>
              <p>
                Kavana Technologies built the <b>EBuy</b> app as a Free app.
                This SERVICE is provided by Kavana Technologies at no cost and
                is intended for use as is.
              </p>{" "}
              <p>
                This page is used to inform visitors regarding our policies with
                the collection, use, and disclosure of Personal Information if
                anyone decided to use our Service.
              </p>{" "}
              <p>
                If you choose to use our Service, then you agree to the
                collection and use of information in relation to this policy.
                The Personal Information that we collect is used for providing
                and improving the Service. We will not use or share your
                information with anyone except as described in this Privacy
                Policy.
              </p>{" "}
              <p>
                The terms used in this Privacy Policy have the same meanings as
                in our Terms and Conditions, which are accessible at EBuy unless
                otherwise defined in this Privacy Policy.
              </p>{" "}
              <h2>
                <strong className="text-base">
                  Information Collection and Use
                </strong>
              </h2>{" "}
              <p>
                For a better experience, while using our Service, we may require
                you to provide us with certain personally identifiable
                information, including but not limited to Name, Email, UserIDs,
                Phone Number,. The information that we request will be retained
                by us and used as described in this privacy policy.
              </p>{" "}
              <div>
                <p>
                  The app does use third-party services that may collect
                  information used to identify you.
                </p>{" "}
                <p>
                  Link to the privacy policy of third-party service providers
                  used by the app
                </p>{" "}
                <ul>
                  <li>
                    <a
                      className="text-accent inline-flex flex-wrap items-center space-x-1"
                      href="https://www.google.com/policies/privacy/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Google Play Services
                    </a>
                  </li>
                </ul>
              </div>{" "}
              <h2>
                <strong>Log Data</strong>
              </h2>{" "}
              <p>
                We want to inform you that whenever you use our Service, in a
                case of an error in the app we collect data and information
                (through third-party products) on your phone called Log Data.
                This Log Data may include information such as your device
                Internet Protocol (“IP”) address, device name, operating system
                version, the configuration of the app when utilizing our
                Service, the time and date of your use of the Service, and other
                statistics.
              </p>{" "}
              <h2>
                <strong>Cookies</strong>
              </h2>{" "}
              <p>
                Cookies are files with a small amount of data that are commonly
                used as anonymous unique identifiers. These are sent to your
                browser from the websites that you visit and are stored on your
                device&ldquo;s internal memory.
              </p>{" "}
              <p>
                This Service does not use these “cookies” explicitly. However,
                the app may use third-party code and libraries that use
                “cookies” to collect information and improve their services. You
                have the option to either accept or refuse these cookies and
                know when a cookie is being sent to your device. If you choose
                to refuse our cookies, you may not be able to use some portions
                of this Service.
              </p>{" "}
              <h2>
                <strong>Service Providers</strong>
              </h2>{" "}
              <p>
                We may employ third-party companies and individuals due to the
                following reasons:
              </p>{" "}
              <ul>
                <li>To facilitate our Service;</li>{" "}
                <li>To provide the Service on our behalf;</li>{" "}
                <li>To perform Service-related services; or</li>{" "}
                <li>To assist us in analyzing how our Service is used.</li>
              </ul>{" "}
              <p>
                We want to inform users of this Service that these third parties
                have access to their Personal Information. The reason is to
                perform the tasks assigned to them on our behalf. However, they
                are obligated not to disclose or use the information for any
                other purpose.
              </p>{" "}
              <h2>
                <strong>Security</strong>
              </h2>{" "}
              <p>
                We value your trust in providing us your Personal Information,
                thus we are striving to use commercially acceptable means of
                protecting it. But remember that no method of transmission over
                the internet, or method of electronic storage is 100% secure and
                reliable, and we cannot guarantee its absolute security.
              </p>{" "}
              <h2>
                <strong>Links to Other Sites</strong>
              </h2>{" "}
              <p>
                This Service may contain links to other sites. If you click on a
                third-party link, you will be directed to that site. Note that
                these external sites are not operated by us. Therefore, we
                strongly advise you to review the Privacy Policy of these
                websites. We have no control over and assume no responsibility
                for the content, privacy policies, or practices of any
                third-party sites or services.
              </p>{" "}
              <h2>
                <strong>Children’s Privacy</strong>
              </h2>{" "}
              <div>
                <p>
                  These Services do not address anyone under the age of 13. We
                  do not knowingly collect personally identifiable information
                  from children under 13 years of age. In the case we discover
                  that a child under 13 has provided us with personal
                  information, we immediately delete this from our servers. If
                  you are a parent or guardian and you are aware that your child
                  has provided us with personal information, please contact us
                  so that we will be able to do the necessary actions.
                </p>
              </div>{" "}
              <h2>
                <strong>Changes to This Privacy Policy</strong>
              </h2>{" "}
              <p>
                We may update our Privacy Policy from time to time. Thus, you
                are advised to review this page periodically for any changes. We
                will notify you of any changes by posting the new Privacy Policy
                on this page.
              </p>{" "}
              <p>This policy is last updated on as of 2022-11-18</p>{" "}
              <h2>
                <strong>Contact Us</strong>
              </h2>{" "}
              <p>
                If you have any questions or suggestions about our Privacy
                Policy, do not hesitate to contact us at kavana.et@gmail.com.
              </p>
            </div>
          </div>
        </section>
        {/* <!-- end TOS --> */}
      </div>
    </div>
  );
};

export default EBuyPrivacyPolicy;
